import moment from "moment";
import React, { useEffect, useContext, useState } from "react";
import { Dialog } from "../../../../../Resources/Scripts/_Shared/elements/Dialog";
import { tempLock } from "../Endpoints";
import { useOrderLines } from '../hooks/useOrderLines';
import { BookingFlowContext } from '../BookingFlowContext';

export const ProductLock = (props) => {
  const { bookingFlowContext, setBookingFlowContext } = useContext(BookingFlowContext);
  if (!bookingFlowContext) return

  //Templock duration in minutes
  const duration = 30;

  const [dateLockedUntil, setDateLockedUntil] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    switch (bookingFlowContext.activeStep) {
      case bookingFlowContext.availableSteps.onlineBooking.index:
      case bookingFlowContext.availableSteps.orderConfirmation.index:
        unLockProducts(bookingFlowContext);
        break;
      case bookingFlowContext.availableSteps.addVehicle.index:
      case bookingFlowContext.availableSteps.orderOverview.index:
        lockProducts(bookingFlowContext);
        break;
    }
  }, [bookingFlowContext.activeStep]);

  useEffect(() => {
    if (timeLeft === null) return;

    let timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const lockProducts = async (bookingFlowContext) => {
    if (bookingFlowContext.availableSteps.onlineBooking.order) {
      updateTempLock(bookingFlowContext);
    } else {
      const response = await useOrderLines(bookingFlowContext.availableSteps.onlineBooking.formData);
      const salesOrderDraft = response.body

      if (response.status === 200) {
        const created = moment.utc(new Date());
        setBookingFlowContext({
          ...bookingFlowContext,
          availableSteps: {
            ...bookingFlowContext.availableSteps,
            onlineBooking: {
              ...bookingFlowContext.availableSteps.onlineBooking,
              update: false,
              order: {
                orderLineId: salesOrderDraft.OrderLines[0].OrderLineId,
                orderLine: salesOrderDraft.OrderLines[0],
                orderId: salesOrderDraft.Uid
              },
            }
          }
        });
        const expiryDate = moment(created).add(duration, 'm');
        setDateLockedUntil(expiryDate);
        setTimeLeft(calculateTimeLeft(expiryDate));
      } else {
        props.setError(response);
      }
    }
  }

  const updateTempLock = async (bookingFlowContext) => {
    const version = bookingFlowContext.availableSteps.onlineBooking.order.orderLine.Version ? '-' + bookingFlowContext.availableSteps.onlineBooking.order.orderLine.Version : '';
    const orderId = bookingFlowContext.availableSteps.onlineBooking.order.orderId;
    const orderLineId = bookingFlowContext.availableSteps.onlineBooking.order.orderLineId + version;
    const updateExpiryDate = moment().add(duration, 'm');
    const response = await tempLock.updateTempLock({ orderId, orderLineId });

    if (response.status === 200) {
      setDateLockedUntil(updateExpiryDate);
      setTimeLeft(calculateTimeLeft(updateExpiryDate));
    }
  }

  const unLockProducts = async (bookingFlowContext) => {
    if (!bookingFlowContext.availableSteps.onlineBooking.order) return;
    const uid = bookingFlowContext.availableSteps.onlineBooking.order.orderId;
    setDateLockedUntil(null);
    setTimeLeft(null);

    const response = bookingFlowContext.activeStep != bookingFlowContext.availableSteps.orderConfirmation.index ? await tempLock.removeTempLock({ uid }) : null;

    setBookingFlowContext({
      ...bookingFlowContext,
      availableSteps: {
        ...bookingFlowContext.availableSteps,
        onlineBooking: {
          ...bookingFlowContext.availableSteps.onlineBooking,
          update: false,
          order: null,
        }
      }
    });
    if (props.currentQuoteSessionKey) sessionStorage.removeItem(props.currentQuoteSessionKey);
  }

  const calculateTimeLeft = (date = dateLockedUntil) => {
    const difference = date - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = {
        none: true
      };
    }

    return timeLeft;
  };

  const handleDialogConfirm = () => {
    updateTempLock(bookingFlowContext);
  }

  const handleDialogCancel = () => {
    props.takeUserToStep(0);
  }

  if (timeLeft !== null && !timeLeft.none && timeLeft.minutes < 5) {
    return (
      <Dialog lang={props.lang} onDialogConfirm={handleDialogConfirm} onDialogCancel={handleDialogCancel}>
        <p>{props.lang.message1} {timeLeft.minutes > 0 && timeLeft.minutes} {timeLeft.minutes > 0 && (timeLeft.minutes === 1 ? props.lang.minute : props.lang.minutes)} {timeLeft.minutes > 0 && props.lang.and} {timeLeft.seconds} {timeLeft.seconds === 1 ? props.lang.second : props.lang.seconds} {props.lang.message2}</p>
        <p>{props.lang.message3}</p>
      </Dialog>
    );
  }

  if (timeLeft !== null && timeLeft.none) {
    return (
      <Dialog lang={props.lang} onDialogConfirm={handleDialogCancel} langHeading={props.lang.bookingexpired} langConfirm={props.lang.ok}>
        <p>{props.lang.bookingexpiredmessage}</p>
      </Dialog>
    );
  }

  return null;
}